import * as AuthModel from 'models/Auth'
import { schemas, validate } from 'validators'
import {
  startSubscription,
  describePaymentSource,
  updatePaymentSource,
} from '../../function'
import { createTokenWithCard } from 'models/Stripe'
import firebase from 'firebase'
import { GET_TWITTER_INFO } from 'request/apollo/queries/account'

export const Mutation = {
  updateEmail: (context, { email, password }, { cache }) => {
    return validate({ email, password }, schemas.updateEmail).then(inputs =>
      AuthModel.updateEmail(inputs.email, inputs.password)
    )
  },
  updatePassword: (
    context,
    { oldPassword, newPassword, confirmPassword },
    { cache }
  ) => {
    return validate(
      { oldPassword, newPassword, confirmPassword },
      schemas.updatePassword
    )
      .then(inputs =>
        AuthModel.updatePassword(inputs.oldPassword, inputs.newPassword)
      )
      .catch(error => {
        throw error
      })
  },
  updateCreditCard: (context, params: updateCreditCardInput, { cache }) => {
    return validate(params, schemas.updateCreditCard)
      .then(inputs =>
        createTokenWithCard({
          number: inputs.number,
          cvc: inputs.cvc,
          expMonth: inputs.expMonth,
          expYear: inputs.expYear,
          name: inputs.name,
        })
      )
      .then(token => updatePaymentSource({ token }))
  },
  subscribeArtist: async (context, { artistId }, { cache }) => {
    return startSubscription({ artistId })
  },
  updateTwitterInfo: (
    context,
    { accountId, displayName, introduction, avatarPath },
    { cache }
  ) => {
    return validate(
      { accountId, displayName, introduction, avatarPath },
      schemas.updateTwitterInfo
    ).then(() => {
      cache.writeQuery({
        query: GET_TWITTER_INFO,
        data: {
          twitterInfo: {
            __typename: 'twitterInfo',
            accountId,
            displayName,
            introduction,
            avatarPath,
          },
        },
      })
    })
  },
  reloadCurrentUser: async (context, _, { cache }) => {
    const user = firebase.auth().currentUser

    if (user) {
      await user.reload()
      return {
        __typename: 'currentUser',
        ...user.toJSON(),
      }
    }

    return null
  },
}

export const Query = {
  getCreditCard: async (): Promise<CreditSource | null> => {
    return describePaymentSource({})
      .then(({ data }) => {
        if (!data) return null

        return {
          __typename: 'CreditCard',
          ...data,
        }
      })
      .catch(e => null)
  },
  currentUser: (_, params, { cache }) => {
    const user = firebase.auth().currentUser

    if (user)
      return {
        __typename: 'currentUser',
        ...user.toJSON(),
      }

    return null
  },
  twitterInfo: (_, params, { cache }) => {
    return {
      __typename: 'twitterInfo',
      ...cache,
    }
  },
}

type CreditSource = {
  name: string | null
  brand: string
  country: string
  expMonth: number
  expYear: number
  last4: string
  __typename?: string
}

type updateCreditCardInput = {
  cardNumber: string
  code: string
  expMonth: string
  expYear: string
  name: String
}
